import { Component } from '@angular/core';

@Component({
    selector: 'app-access-forbidden',
    templateUrl: './access-forbidden.component.html',
    standalone: false
})
export class AccessForbiddenComponent {
}
